class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (!this.mainDetailsToggle) return;

    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary ? this.summary.nextElementSibling : null;

    this.onFocusOut = this.onFocusOut.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onEscape = this.onEscape.bind(this);

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut);
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle);
    this.addEventListener('keydown', this.onEscape);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    }, 150);
  }

  onToggle() {
    if (!this.summary) return;

    this.summary.setAttribute(
      'aria-expanded',
      this.mainDetailsToggle.open ? 'true' : 'false'
    );

    if (!this.content || typeof this.content.getAnimations !== 'function') {
      return;
    }

    const animations = this.content.getAnimations();

    animations.forEach((animation) => {
      if (this.mainDetailsToggle.open) {
        animation.play();
      } else {
        animation.cancel();
      }
    });
  }

  onEscape(event) {
    if (event.key !== 'Escape') return;
    if (!this.mainDetailsToggle.open) return;

    this.close();

    if (this.summary) {
      this.summary.focus();
    }
  }

  open() {
    if (!this.mainDetailsToggle || !this.summary) return;

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (!this.mainDetailsToggle || !this.summary) return;

    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', DetailsDisclosure);
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    if (!this.mainDetailsToggle || !this.summary) return;

    this.header =
      document.querySelector('sticky-header.header-wrapper') ||
      document.querySelector('.header-wrapper');

    this.desktop = window.matchMedia('(min-width: 990px)');
    this.closeTimer = null;
    this.hoverDelay = 280;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.updateMenuPosition = this.updateMenuPosition.bind(this);

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.summary.addEventListener('click', this.onSummaryClick);

    window.addEventListener('resize', this.updateMenuPosition, {
      passive: true
    });

    window.addEventListener('scroll', this.updateMenuPosition, {
      passive: true
    });
  }

  closeOtherMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') {
        menu.close();
      }
    });
  }

  updateMenuPosition() {
    if (!this.desktop.matches) return;
    if (!this.header) return;

    const headerBottom = Math.round(
      this.header.getBoundingClientRect().bottom
    );

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${headerBottom}px`
    );
  }

  onMouseEnter() {
    if (!this.desktop.matches) return;

    clearTimeout(this.closeTimer);

    this.closeOtherMenus();
    this.updateMenuPosition();
    this.open();
  }

  onMouseLeave() {
    if (!this.desktop.matches) return;

    clearTimeout(this.closeTimer);

    this.closeTimer = setTimeout(() => {
      const focusInside = this.contains(document.activeElement);
      const mouseInside = this.matches(':hover');

      if (!focusInside && !mouseInside) {
        this.close();
      }
    }, this.hoverDelay);
  }

  onSummaryClick(event) {
    if (!this.desktop.matches) return;

    event.preventDefault();
    clearTimeout(this.closeTimer);

    if (this.mainDetailsToggle.open) {
      this.close();
    } else {
      this.closeOtherMenus();
      this.updateMenuPosition();
      this.open();
    }
  }

  onToggle() {
    super.onToggle();

    if (this.header) {
      this.header.preventHide = this.mainDetailsToggle.open;
    }

    if (this.mainDetailsToggle.open) {
      this.updateMenuPosition();
    }
  }
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu);
}
